// extracted by mini-css-extract-plugin
module.exports = {"root":"root___3yHK8","loading":"loading___2GEGZ"};